import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Search, X, Clock, ChevronRight } from "lucide-react";

// Mock Data
const HERITAGE_FILMS = [
  {
    id: 1,
    title: "Sambizanga",
    originalYear: 1972,
    country: "Angola",
    director: "Sarah Maldoror",
    genre: "Historical Drama",
    rating: 4.8,
    duration: "1h 42m",
    restoredQuality: "4K",
    image: "https://images.unsplash.com/photo-1489599849927-2ee91cede3ba?w=600&h=900&fit=crop",
    description: "A powerful depiction of Angola's struggle for independence.",
    language: "Portuguese",
    significance: "Landmark of African revolutionary cinema",
  },
  {
    id: 2,
    title: "Touki Bouki",
    originalYear: 1973,
    country: "Senegal",
    director: "Djibril Diop Mambéty",
    genre: "Avant-Garde Drama",
    rating: 4.9,
    duration: "1h 29m",
    restoredQuality: "4K",
    image: "https://images.unsplash.com/photo-1536440136628-849c177e76a1?w=600&h=900&fit=crop",
    description: "A young couple dreams of escaping Dakar for Paris.",
    language: "Wolof/French",
    significance: "Pioneering work of African new wave cinema",
  },
  {
    id: 3,
    title: "Black Girl",
    originalYear: 1966,
    country: "Senegal",
    director: "Ousmane Sembène",
    genre: "Drama",
    rating: 4.7,
    duration: "1h 5m",
    restoredQuality: "2K",
    image: "https://images.unsplash.com/photo-1485846234645-a62644f84728?w=600&h=900&fit=crop",
    description: "The first feature film by an African filmmaker to gain international recognition.",
    language: "French/Wolof",
    significance: "Birth of modern African cinema",
  },
];

const COLLECTIONS = [
  {
    id: 7,
    title: "The Battle of Algiers",
    originalYear: 1966,
    country: "Algeria/Italy",
    director: "Gillo Pontecorvo",
    genre: "War/Historical",
    rating: 4.9,
    duration: "2h 1m",
    restoredQuality: "4K",
    image: "https://images.unsplash.com/photo-1574267432644-f610c39ce1c6?w=600&h=900&fit=crop",
    description: "Powerful depiction of the Algerian struggle for independence.",
    language: "Arabic/French",
    significance: "Golden Lion winner, revolutionary cinema landmark",
  },
];

const Discover = () => {
  useEffect(() => {
  try {
    const adEl = document.querySelector(".adsbygoogle");
    // Only push if the slot hasn't been filled yet
    if (adEl && !adEl.getAttribute("data-adsbygoogle-status")) {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    }
  } catch (e) {
    console.error("AdSense error:", e);
  }
}, []);
  
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [recentSearches] = useState([
    "Ousmane Sembène Films",
    "1970s Classics",
    "Senegalese Cinema",
  ]);

  const handleDetailClick = (film) => {
    navigate("/detail", { state: { content: film } });
  };

  const allFilms = [...HERITAGE_FILMS, ...COLLECTIONS];

  const filteredFilms = searchTerm
    ? allFilms.filter(
        (item) =>
          item.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.director.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.country.toLowerCase().includes(searchTerm.toLowerCase())
      )
    : [];

  return (
    <div className="search-container fade-in-up">
      <h1 className="section-title" style={{ marginBottom: "24px" }}>
        Discover Heritage
      </h1>

      <div className="search-bar">
        <Search className="search-icon" size={22} />
        <input
          type="text"
          className="search-input"
          placeholder="Search classic films, directors, countries..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        {searchTerm && (
          <button className="clear-search" onClick={() => setSearchTerm("")}>
            <X size={18} />
          </button>
        )}
      </div>

      {!searchTerm && (
        <div className="recent-searches">
          <h3
            className="section-title"
            style={{ marginBottom: "18px", fontSize: "20px" }}
          >
            Recent Searches
          </h3>
          {recentSearches.map((search, idx) => (
            <div
              key={idx}
              className="recent-item"
              onClick={() => setSearchTerm(search)}
            >
              <div className="recent-item-text">
                <Clock size={20} />
                {search}
              </div>
              <ChevronRight size={20} />
            </div>
          ))}
        </div>
      )}

      {searchTerm && (
        <div className="content-grid">
          {filteredFilms.map((item) => (
            <div
              key={item.id}
              className="content-card"
              onClick={() => handleDetailClick(item)}
            >
              <img
                src={item.image}
                alt={item.title}
                className="content-card-image"
              />
              <span className="quality-badge">{item.restoredQuality}</span>
              <div className="content-card-info">
                <div className="content-card-title">{item.title}</div>
                <div className="content-card-meta">
                  {item.originalYear} • {item.country}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {searchTerm && filteredFilms.length === 0 && (
        <div style={{ textAlign: "center", padding: "60px 20px" }}>
          <p style={{ color: "var(--text-tertiary)", fontSize: "16px" }}>
            No results found for "{searchTerm}"
          </p>
        </div>
      )}
      {/* ✅ Ad banner inside the single return, at the bottom */}
      <ins className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client="ca-pub-XXXXXXXX"
        data-ad-slot="XXXXXXXX"
        data-ad-format="auto">
      </ins>
    </div>
  );
};

export default Discover;